import { LocaleLink } from '../../../i18n/locale-link';
import { formatCount } from '../../../lib/format';

export interface CounterItem {
  value: number | undefined;
  label: string;
  /** Вторая половина подписи, зелёная («639 добавили за сутки»). */
  accent?: string | null;
  href: string;
}

interface Props {
  items: CounterItem[];
  onClick: (label: string) => void;
}

/**
 * Счётчики-плитки: живые цифры каталога, каждая — ссылка на источник данных
 * (каталог, результаты, МФИ). Пока `value === undefined` рисуем «—», а не 0 —
 * ноль тендеров это утверждение, отсутствие данных нет.
 */
export function Counters({ items, onClick }: Props) {
  return (
    <section className="pb-2 pt-11">
      <div className="mx-auto max-w-[1120px] px-5">
        <div className="grid gap-3.5 md:grid-cols-4">
          {items.map((item) => (
            <LocaleLink
              key={item.label}
              to={item.href}
              onClick={() => onClick(item.label)}
              className="block rounded-xl border border-edge bg-bone-surface p-5 text-ink no-underline shadow-m-sm transition hover:-translate-y-0.5 hover:border-brand"
            >
              <div className="text-[clamp(23px,2.8vw,29px)] font-extrabold tracking-[-0.02em] text-brand">
                {item.value === undefined ? '—' : formatCount(item.value)}
              </div>
              <div className="mt-1 text-[13.5px] leading-[1.4] text-ink-soft">
                {item.label}
                {item.accent ? (
                  <>
                    {' · '}
                    <b className="font-bold text-status-active-text">{item.accent}</b>
                  </>
                ) : null}
              </div>
            </LocaleLink>
          ))}
        </div>
      </div>
    </section>
  );
}
